{
  "version": "0.2.11",
  "extensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "sha256": "b85a04ea8aeb7e82127b2fa1947b2ebbf8899dea5647b5a089e4310cb64c0233",
  "bytes": 81593,
  "download": "https://gab.ai/browser-extension/gab-ai-browser-extension-preview.zip",
  "channel": "manual-preview",
  "chatOrigin": "https://gab.ai"
}
